(() => {
  const prefersReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ACCESS_KEY = 'etMuseumAccessGranted_v322';
  const hasMuseumAccess = () => { try { return localStorage.getItem(ACCESS_KEY) === 'true' || sessionStorage.getItem(ACCESS_KEY) === 'true'; } catch (_) { return false; } };
  const grantMuseumAccess = () => { try { localStorage.setItem(ACCESS_KEY, 'true'); sessionStorage.setItem(ACCESS_KEY, 'true'); } catch (_) {} document.body.classList.add('et-museum-access-granted'); };
  const revokeMuseumAccess = () => { try { localStorage.removeItem(ACCESS_KEY); sessionStorage.removeItem(ACCESS_KEY); } catch (_) {} document.body.classList.remove('et-museum-access-granted'); };

  function playMuseumSound(kind, enabled) {
    if (!enabled) return;
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      const ctx = new AC();
      const now = ctx.currentTime;
      const master = ctx.createGain();
      master.gain.setValueAtTime(0.0001, now);
      master.gain.exponentialRampToValueAtTime(kind === 'open' ? 0.085 : 0.07, now + 0.05);
      master.gain.exponentialRampToValueAtTime(0.0001, now + 2.5);
      master.connect(ctx.destination);

      const latch = ctx.createOscillator();
      const latchGain = ctx.createGain();
      latch.type = 'triangle';
      latch.frequency.setValueAtTime(kind === 'open' ? 130 : 105, now);
      latch.frequency.exponentialRampToValueAtTime(58, now + .25);
      latchGain.gain.setValueAtTime(.45, now);
      latchGain.gain.exponentialRampToValueAtTime(.0001, now + .32);
      latch.connect(latchGain); latchGain.connect(master);
      latch.start(now); latch.stop(now + .34);

      const creak = ctx.createOscillator();
      const filter = ctx.createBiquadFilter();
      const creakGain = ctx.createGain();
      creak.type = 'sawtooth';
      creak.frequency.setValueAtTime(kind === 'open' ? 48 : 42, now + .18);
      creak.frequency.linearRampToValueAtTime(kind === 'open' ? 29 : 34, now + 1.75);
      filter.type = 'lowpass'; filter.frequency.value = 240;
      creakGain.gain.setValueAtTime(.0001, now + .15);
      creakGain.gain.exponentialRampToValueAtTime(.22, now + .45);
      creakGain.gain.exponentialRampToValueAtTime(.0001, now + 2.05);
      creak.connect(filter); filter.connect(creakGain); creakGain.connect(master);
      creak.start(now + .15); creak.stop(now + 2.1);

      const step = ctx.createOscillator();
      const stepGain = ctx.createGain();
      step.type = 'sine'; step.frequency.value = 52;
      stepGain.gain.setValueAtTime(.0001, now + 1.25);
      stepGain.gain.exponentialRampToValueAtTime(.14, now + 1.32);
      stepGain.gain.exponentialRampToValueAtTime(.0001, now + 1.5);
      step.connect(stepGain); stepGain.connect(master);
      step.start(now + 1.25); step.stop(now + 1.52);
      setTimeout(() => ctx.close().catch(() => {}), 2900);
    } catch (_) {}
  }

  function initMuseum(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const doorTrigger = root.querySelector('[data-et-door-trigger]');
    const hallButton = root.querySelector('[data-et-enter-hall]');
    const hall = root.querySelector('[data-et-grand-hall]');
    const exitDoors = root.querySelector('[data-et-exit-doors]');
    const closeButtons = [...root.querySelectorAll('[data-et-overlay-close]')];
    const galleryDoors = [...root.querySelectorAll('[data-et-gallery-door]')];
    const returnLogo = root.querySelector('[data-et-return-logo]');
    const searchGate = root.querySelector('[data-et-search-gate]');
    const searchEnter = root.querySelector('[data-et-search-enter]');
    const searchClose = root.querySelector('[data-et-search-close]');
    const enabled = root.dataset.doorSound === 'true';
    const catalog = document.querySelector('.et-home .et-collections');
    const siteHeader = document.querySelector('.shopify-section-group-header-group') || document.querySelector('#shopify-section-header') || document.querySelector('header');
    let pendingGallery = null;
    let openTimer;
    let menuObserver;

    const getDesktopMenuItems = () => {
      const selectors = [
        '.header__inline-menu .list-menu--inline > li',
        '.header__inline-menu > ul > li',
        'nav.header__inline-menu li'
      ];
      const found = [];
      selectors.forEach(selector => document.querySelectorAll(selector).forEach(item => {
        if (!found.includes(item)) found.push(item);
      }));
      return found.filter(item => item.querySelector('a, summary'));
    };

    const applyHeaderState = () => {
      /* Museum is optional: navigation remains fully available at all times. */
      const items = getDesktopMenuItems();
      items.forEach((item, index) => {
        item.classList.add('et-guided-menu-item');
        item.classList.toggle('et-menu-home', index === 0);
        item.classList.remove('et-menu-locked');
        item.setAttribute('aria-disabled', 'false');
        const control = item.querySelector('a, summary');
        if (control) control.removeAttribute('tabindex');
      });
    };

    const pulseHome = () => {
      const item = getDesktopMenuItems()[0];
      const control = item && item.querySelector('a, summary');
      if (!control) return;
      control.classList.remove('et-home-link-feedback');
      void control.offsetWidth;
      control.classList.add('et-home-link-feedback');
      window.setTimeout(() => control.classList.remove('et-home-link-feedback'), 600);
    };

    const resetMuseum = (revokeAccess = false) => {
      clearTimeout(openTimer);
      clearTarget();
      root.className = 'et-museum';
      if (searchGate) searchGate.setAttribute('aria-hidden','true');
      root.setAttribute('aria-hidden','true');
      hall.setAttribute('aria-hidden','true');
      const welcome = root.querySelector('[data-et-welcome]');
      if (welcome) welcome.setAttribute('aria-hidden','true');
      pendingGallery = null;
      document.documentElement.classList.remove('et-museum-lock');
      document.body.classList.remove('et-museum-lock','et-museum-has-entered');
      if (revokeAccess) revokeMuseumAccess();
      root.style.removeProperty('--et-museum-header-height');
      applyHeaderState(hasMuseumAccess());
    };
    const clearTarget = () => galleryDoors.forEach(x => x.classList.remove('is-targeted'));
    const showOverlay = (index = null) => {
      pendingGallery = Number.isInteger(index) ? index : null;
      clearTarget();
      document.body.classList.remove('et-museum-has-entered');
      root.className = 'et-museum is-visible';
      root.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('et-museum-lock');
      document.body.classList.add('et-museum-lock');
      applyHeaderState(false);
      window.setTimeout(() => doorTrigger.focus({preventScroll:true}), 120);
    };
    const showSearchPrompt = () => {
      pendingGallery = null;
      clearTarget();
      document.body.classList.remove('et-museum-has-entered');
      root.className = 'et-museum is-visible is-search-prompt';
      root.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('et-museum-lock');
      document.body.classList.add('et-museum-lock');
      applyHeaderState(false);
      if (searchGate) searchGate.setAttribute('aria-hidden','false');
      window.setTimeout(() => searchEnter && searchEnter.focus({preventScroll:true}), 120);
    };
    const dismissSearchPromptToDoors = () => {
      root.classList.remove('is-search-prompt');
      if (searchGate) searchGate.setAttribute('aria-hidden','true');
      window.setTimeout(() => doorTrigger && doorTrigger.focus({preventScroll:true}), 80);
    };
    const closeSearchPrompt = () => {
      resetMuseum();
      const input = document.querySelector('.et-search-input');
      if (input) input.blur();
    };

    const hideOverlay = () => {
      clearTimeout(openTimer);
      root.classList.add('is-closing');
      playMuseumSound('close', enabled);
      document.body.classList.remove('et-museum-has-entered');
      const cinematicExit = root.classList.contains('is-exit-cinema');
      const closeDuration = prefersReduced() ? 20 : (cinematicExit ? 2250 : 1050);
      window.setTimeout(() => {
        root.classList.add('is-logo-return');
        window.setTimeout(() => {
          root.classList.add('is-logo-fading');
          window.setTimeout(() => {
            resetMuseum(true);
            (catalog || document.querySelector('.et-home') || document.body).scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'});
          }, prefersReduced() ? 20 : 720);
        }, prefersReduced() ? 20 : 900);
      }, closeDuration);
    };
    const openDoors = () => {
      if (root.classList.contains('is-opening') || root.classList.contains('is-welcome')) return;
      root.classList.add('is-opening');
      playMuseumSound('open', enabled);
      openTimer = window.setTimeout(() => { root.classList.add('is-welcome'); const welcome = root.querySelector('[data-et-welcome]'); if (welcome) welcome.setAttribute('aria-hidden','false'); }, prefersReduced() ? 10 : 3300);
    };
    const enterHall = () => {
      root.classList.remove('is-welcome');
      root.classList.add('is-in-hall');
      document.body.classList.add('et-museum-has-entered');
      grantMuseumAccess();
      applyHeaderState(true);
      const headerHeight = siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0;
      root.style.setProperty('--et-museum-header-height', `${headerHeight}px`);
      window.scrollTo({top:0, behavior:prefersReduced()?'auto':'smooth'});
      const welcome = root.querySelector('[data-et-welcome]');
      if (welcome) welcome.setAttribute('aria-hidden','true');
      hall.setAttribute('aria-hidden','false');
      hall.scrollTop = 0;
      window.setTimeout(() => {
        hall.scrollTop = 0;
        if (Number.isInteger(pendingGallery) && galleryDoors[pendingGallery]) {
          const door = galleryDoors[pendingGallery];
          door.classList.add('is-targeted');
          /* Remember the collection chosen outside the museum and bring its gallery
             doorway into view after the Hall has opened. */
          window.setTimeout(() => {
            hall.scrollTop = 0;
            try { hall.scrollTo({ top: 0, behavior: prefersReduced() ? 'auto' : 'smooth' }); } catch (_) {}
            try { door.focus({ preventScroll: true }); } catch (_) {}
          }, prefersReduced() ? 0 : 250);
        }
      }, prefersReduced() ? 0 : 650);
    };

    hall.addEventListener('pointermove', (event) => {
      const rect = hall.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      hall.style.setProperty('--et-mouse-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      hall.style.setProperty('--et-mouse-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
    });

    doorTrigger.addEventListener('click', openDoors);
    if (searchEnter) searchEnter.addEventListener('click', dismissSearchPromptToDoors);
    if (searchClose) searchClose.addEventListener('click', closeSearchPrompt);
    hallButton.addEventListener('click', enterHall);
    exitDoors.addEventListener('click', hideOverlay);
    closeButtons.forEach(btn => btn.addEventListener('click', hideOverlay));
    document.addEventListener('et:show-museum-doors', () => {
      if (hasMuseumAccess()) return;
      showOverlay(null);
    });
    document.addEventListener('et:exit-museum', () => {
      clearTimeout(openTimer);
      root.className = 'et-museum is-visible is-exit-cinema';
      root.setAttribute('aria-hidden','false');
      hall.setAttribute('aria-hidden','true');
      document.documentElement.classList.add('et-museum-lock');
      document.body.classList.add('et-museum-lock','et-museum-has-entered');
      window.setTimeout(hideOverlay, prefersReduced() ? 10 : 180);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('is-visible')) hideOverlay(); });

    /* Search is unlocked only after the visitor enters The Hall of Earth Treasures. */
    const isInsideMuseum = () => true;
    document.addEventListener('pointerdown', (event) => {
      const searchTarget = event.target.closest('.et-header-search, .et-search-form, .et-search-field, .et-search-input, .header__search, details-modal.header__search');
      if (!searchTarget || isInsideMuseum()) return;
      event.preventDefault();
      event.stopPropagation();
      const input = searchTarget.querySelector ? searchTarget.querySelector('input[type=search]') : null;
      if (input) input.blur();
      showSearchPrompt();
    }, true);
    document.addEventListener('focusin', (event) => {
      if (!event.target.matches('.et-search-input, input[type=search]') || isInsideMuseum()) return;
      event.target.blur();
      showSearchPrompt();
    }, true);
    document.addEventListener('submit', (event) => {
      if (!event.target.matches('.et-search-form, form[action*=\"/search\"]') || isInsideMuseum()) return;
      event.preventDefault();
      event.stopPropagation();
      showSearchPrompt();
    }, true);

    /* Home is museum-aware: outside it gives visible page movement; inside it returns to the Hall's main entrance without closing the museum. */
    document.addEventListener('click', (event) => {
      const item = event.target.closest('.et-never-intercept-home');
      if (!item) return;
      event.preventDefault();
      event.stopPropagation();
      pulseHome();
      if (hasMuseumAccess()) {
        /* Museum access lasts for the browser session. Home returns to the storefront without locking the museum again. */
        if (window.location.pathname === '/' && !root.classList.contains('is-visible')) {
          window.scrollTo({top:0, behavior:prefersReduced()?'auto':'smooth'});
        } else {
          window.location.assign('/');
        }
      } else if (root.classList.contains('is-visible')) {
        clearTimeout(openTimer);
        clearTarget();
        root.className = 'et-museum is-visible';
        const welcome = root.querySelector('[data-et-welcome]');
        if (welcome) welcome.setAttribute('aria-hidden','true');
        hall.setAttribute('aria-hidden','true');
        pendingGallery = null;
      } else {
        const destination = Math.min(220, Math.max(120, Math.round(window.innerHeight * 0.18)));
        window.scrollTo({top:destination,behavior:prefersReduced()?'auto':'smooth'});
      }
    }, true);

    /* Re-apply the guided menu if Shopify redraws the header in preview/customizer. */
    if (hasMuseumAccess()) document.body.classList.add('et-museum-access-granted');
    applyHeaderState(hasMuseumAccess());
    let pendingExit = false;
    try { pendingExit = sessionStorage.getItem('etMuseumPendingExit') === 'true'; sessionStorage.removeItem('etMuseumPendingExit'); } catch (_) {}
    try { pendingExit = pendingExit || new URLSearchParams(window.location.search).get('museum_exit') === '1'; } catch (_) {}
    let pendingEnter = false;
    try { pendingEnter = sessionStorage.getItem('etMuseumPendingEnter') === 'true'; sessionStorage.removeItem('etMuseumPendingEnter'); } catch (_) {}
    try { pendingEnter = pendingEnter || new URLSearchParams(window.location.search).get('museum_enter') === '1'; } catch (_) {}
    if (pendingEnter && !hasMuseumAccess()) {
      try { history.replaceState({}, '', window.location.pathname); } catch (_) {}
      window.setTimeout(() => showOverlay(null), 80);
    }
    if (pendingExit && hasMuseumAccess()) {
      root.className = 'et-museum is-visible is-exit-cinema';
      root.setAttribute('aria-hidden','false');
      hall.setAttribute('aria-hidden','true');
      document.documentElement.classList.add('et-museum-lock');
      document.body.classList.add('et-museum-lock','et-museum-has-entered');
      window.setTimeout(hideOverlay, prefersReduced() ? 10 : 240);
    }
    menuObserver = new MutationObserver(() => applyHeaderState(hasMuseumAccess()));
    menuObserver.observe(document.documentElement,{childList:true,subtree:true});

    document.addEventListener('click', (event) => {
      const card = event.target.closest('.et-home [data-et-card]');
      if (false && card && !hasMuseumAccess()) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        const i = Number(card.dataset.etCard); showOverlay(Number.isFinite(i) ? i : null); return;
      }
      const heroImage = event.target.closest('.et-home [data-et-hero-image-link]');
      if (false && heroImage && !hasMuseumAccess()) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        const i = Number(heroImage.dataset.etHeroImageLink); showOverlay(Number.isFinite(i) ? i : null); return;
      }
      const heroButton = event.target.closest('.et-home .et-hero__panel .et-button');
      if (false && heroButton && !hasMuseumAccess()) {
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
        const all = [...document.querySelectorAll('.et-home .et-hero__panel .et-button')];
        const i = all.indexOf(heroButton); showOverlay(i >= 0 ? i : null);
      }
    }, true);
  }

  const initAll = () => document.querySelectorAll('[data-et-museum]').forEach(initMuseum);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
